import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  AppBar,
  Box,
  Button,
  CardActions,
  Divider,
  IconButton,
  Tooltip,
} from '@mui/material';
import {func, object} from 'prop-types';
import React, {useEffect, useState} from 'react';

import PermissionsFilter from './CollectionFilters/PermissionsFilter.jsx';

import {trackEvent} from '@app/analytics';
import DrawerHeader from '@components/common/DrawerHeader';

const FilterMenu = ({onClose, filters, setFilters, resetFilters}) => {
  const [checkedFilters, setCheckedFilters] = useState(filters);

  const handlePermissionFilters = e => {
    if (e.target.checked) {
      setCheckedFilters({
        ...checkedFilters,
        [e.target.name]: e.target.checked,
      });
    } else {
      const tmpFilters = {...checkedFilters};
      delete tmpFilters[e.target.name];
      setCheckedFilters(tmpFilters);
    }
  };

  const handleFilters = () => {
    setFilters(checkedFilters);
    onClose();
    trackEvent('Filter Menu', {
      action: 'Filters applied',
      ...checkedFilters,
    });
  };

  const handleClear = () => {
    resetFilters();
    trackEvent('Filter Menu', {
      action: 'Filters cleared',
    });
  };

  useEffect(() => {
    setCheckedFilters(filters);
  }, [filters]);

  return (
    <>
      <DrawerHeader
        title="Filters"
        avatar={
          <>
            <Tooltip title="Back to Collections">
              <IconButton onClick={onClose} size="small">
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
            <Divider
              orientation="vertical"
              flexItem
              sx={{marginLeft: 0.5, marginY: 0.5}}
            />
          </>
        }
      />
      <Box
        sx={{
          height: '100%',
          paddingX: 1,
          paddingY: 2,
          flexGrow: 1,
        }}
      >
        <PermissionsFilter
          checkedFilters={checkedFilters}
          onChange={handlePermissionFilters}
        />
      </Box>
      <AppBar position="static" elevation={0} color="transparent">
        <Divider />
        <CardActions sx={{justifyContent: 'space-between'}}>
          <Button fullWidth color="primary" onClick={handleClear}>
            Clear all
          </Button>
          <Button
            variant="contained"
            fullWidth
            color="primary"
            onClick={handleFilters}
          >
            Apply filters
          </Button>
        </CardActions>
      </AppBar>
    </>
  );
};

FilterMenu.propTypes = {
  onClose: func,
  filters: object.isRequired,
  setFilters: func.isRequired,
  resetFilters: func.isRequired,
};

export default FilterMenu;
